import React, { useEffect } from 'react';
import * as THREE from 'three';

const ThreeDAnimation = () => {
  useEffect(() => {
    // Initialize Three.js scene
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer();
    renderer.setSize(window.innerWidth, window.innerHeight);
    const animationContainer = document.getElementById('3d-animation');
    if (animationContainer) {
      animationContainer.appendChild(renderer.domElement);
    }

    // Create a geometry and material for the 3D objects
    const geometry = new THREE.SphereGeometry(1, 32, 32);
    const material = new THREE.MeshStandardMaterial({ color: 0x0077ff });

    // Create multiple spheres and add them to the scene
    for (let i = 0; i < 50; i++) {
      const sphere = new THREE.Mesh(geometry, material);
      sphere.position.set(
        (Math.random() - 0.5) * 20,
        (Math.random() - 0.5) * 20,
        (Math.random() - 0.5) * 20
      );
      scene.add(sphere);
    }

    // Add lighting to the scene
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
    scene.add(ambientLight);

    const pointLight = new THREE.PointLight(0xffffff, 1);
    pointLight.position.set(5, 5, 5);
    scene.add(pointLight);

    camera.position.z = 5;

    // Animation loop
    const animate = function () {
      requestAnimationFrame(animate);

      scene.rotation.x += 0.001;
      scene.rotation.y += 0.001;

      renderer.render(scene, camera);
    };

    animate();

    // Clean up on component unmount
    return () => {
      if (animationContainer) {
        animationContainer.removeChild(renderer.domElement);
      }
    };
  }, []);

  return <div id="3d-animation" style={{ width: '100%', height: '400px' }}></div>;
};

export default ThreeDAnimation;
